export default __webpack_public_path__ + "static/media/header.b5007f81.png";